let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jm4UB")).then(() => parcelRequire('kVtgP'));